/*
 * The opening screen in index.html: it shows while the code loads, for at least the length of
 * its animation, then fades out (the menu then shows over a still of the airport). Hidden at most after MAX_MS whatever
 * happens, so a failed load never leaves the player in front of it.
 */

const MIN_MS = 2200;
const MAX_MS = 12_000;

let hidden = false;

export function hideSplash(): void {
  if (hidden) return;
  hidden = true;
  const splash = document.getElementById('splash');
  if (!splash) return;
  window.setTimeout(
    () => {
      splash.classList.add('gone');
      window.setTimeout(() => splash.remove(), 900);
    },
    Math.max(0, MIN_MS - performance.now()),
  );
}

window.setTimeout(hideSplash, MAX_MS);
